import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ZoomIn, X, ChevronLeft, ChevronRight } from 'lucide-react';
import { WaChannelLink } from '../../lib/whatsappChannel';

// Placeholder flyer data (akan diganti dengan gambar Thubaproject asli)
export const flyers = [
    {
        id: 1,
        title: 'Adab Menyambut Saudara',
        tag: 'Adab',
        src: '/flayer 080326/Adab Menyambut Saudara.jpeg',
        color: '#10b981',
        desc: `AWAL RAMADHAN MASJID PENUH, JANGAN JUTEK! 😊

Awal Ramadhan selalu membawa suasana berbeda. Shaf shalat merapat, masjid penuh sesak, dan banyak wajah baru yang antusias ikut tarawih maupun duduk di majelis ilmu.

Sesuai faedah indah dari Ustadz Abu Haidar As-Sundawy hafizhahullah di atas, mari kita sambut saudara-saudara kita ini dengan kehangatan.

Bagi antum yang sudah lebih dulu mengenal sunnah atau aktif di masjid, jangan pasang wajah masam (jutek) hanya karena shaf favorit antum tergeser, atau melihat penampilan mereka yang mungkin belum terbiasa dengan sunnah.

Sapa mereka, berikan senyuman, dan buat mereka nyaman. Bisa jadi, kehangatan sikap antum adalah jalan hidayah yang membuat mereka terus istiqamah ke masjid meski Ramadhan telah usai.

Jadilah jembatan hidayah, bukan tembok penghalang. Barakallahu fiikum.`
    },
    {
        id: 2,
        title: 'Berjalan Tanpa Cahaya',
        tag: 'Nasehat',
        src: '/flayer 080326/Berjalan Tanpa Cahaya.jpeg',
        color: '#f59e0b',
        desc: `KEZALIMAN ADALAH KEGELAPAN

Hati-hati dengan perbuatan zalim, baik kepada Allah, kepada sesama manusia, maupun kepada diri sendiri. Karena kelak di hari kiamat, ia akan menjadi kegelapan yang menyusahkan pelakunya.

Rasulullah shallallahu 'alaihi wa sallam bersabda:

الظُّلْمُ ظُلُماتٌ يَومَ القِيامَةِ.
الراوي: عبدالله بن عمر • البخاري، صحيح البخاري (٢٤٤٧) • [صحيح] • أخرجه البخاري (٢٤٤٧ )، ومسلم (٢٥٧٩)

"Sesungguhnya kezaliman itu mendatangkan kegelapan pada hari kiamat kelak."

Semoga Allah lindungi kita dari berbuat zalim dan dizalimi.`
    },
    {
        id: 3,
        title: 'Kurangi Keramaian',
        tag: 'Muhasabah',
        src: '/flayer 080326/Kurangi Keramaian.jpeg',
        color: '#3b82f6',
        desc: `KURANGI KERAMAIAN, PERBANYAK BACA AL-QUR'AN 📖

Seringkali Ramadhan kita habis dengan kesibukan duniawi: jadwal bukber yang padat, nongkrong malam, hingga sibuk mengomentari hal yang tidak bermanfaat.

Mari sejenak merenungi nasihat emas dari Imam Sufyan Ats-Tsauri rahimahullah:

"Hendaknya engkau bertaqwa kepada Allah Ta'ala, lakukanlah uzlah (menyendiri), sibuklah dengan dirimu, dan hiburlah dirimu dengan Al Quran."

📘(Al-Jarh wa At-Ta'dil 1/87)

Bulan suci ini adalah waktu terbaik untuk sedikit "menarik diri" dari hiruk-pikuk manusia yang melalaikan. Sibukkan diri dengan mengoreksi aib sendiri, memperbanyak istighfar, dan jadikan Al-Qur'an sebagai teman duduk terbaik kita siang dan malam, sebagaimana kebiasaan para Salafush Shalih.

Semoga Allah bimbing kita untuk memaksimalkan ibadah. Barakallahu fiikum.`
    },
    {
        id: 4,
        title: 'Menjadi Manusia yang Bermanfaat',
        tag: 'Inspirasi',
        src: '/flayer 080326/Menjadi Manusia Manfaat.jpeg',
        color: '#a855f7',
        desc: `HIDUP BUKAN SEKADAR TENTANG DIRI SENDIRI

"Kita harus bermanfaat untuk umat, tidak boleh hanya mengurus diri kita sendiri."

Keberkahan seorang muslim terletak pada seberapa besar manfaat yang ia tebar untuk saudaranya. Jangan sampai kita sibuk dengan ego sendiri hingga lupa mengambil peran untuk umat.

Di mana pun kita berada, pastikan kehadiran kita membawa kebaikan.

Jadilah manusia yang mubarak.

#ThubaProject #UstadzYazid #NasihatUlama #Manfaat #Khoirunnas #SelfReminder #DakwahSunnah`
    },
    {
        id: 5,
        title: 'Meringankan Beban Di Bulan Ampunan',
        tag: 'Ramadhan',
        src: '/flayer 080326/Meringankan Beban Dibulan Penuh Ampunan.jpeg',
        color: '#f43f5e',
        desc: `Meringankan Beban di Bulan Penuh Ampunan

Ramadhan bukan hanya madrasah untuk menahan hawa nafsu, tetapi juga momen paling utama untuk melatih kepedulian. Jangan biarkan bulan yang penuh berkah ini berlalu tanpa jejak kebaikan yang kita bagikan untuk saudara-saudara kita yang sedang kesulitan.

Mari raih keutamaan sedekah di bulan Ramadhan sebagaimana yang dinasihatkan oleh para ulama kita.`
    },
    {
        id: 6,
        title: 'Pintu Itu Bisa Tertutup Kapan Saja',
        tag: 'Muhasabah',
        src: '/flayer 080326/Pintu Itu Bisa Tertutup Kapan Saja.jpeg',
        color: '#06b6d4',
        desc: `Pintu Kebaikan Tidak Selamanya Terbuka

Jangan biasakan menunda beramal dengan kata "nanti". Kita tidak pernah tahu kapan Allah akan mencabut kemampuan atau kesempatan itu dari kita.

Seorang Tabi’in, Khâlid bin Ma’dân rahimahullah berpesan tegas:

"Bila telah terbuka bagi salah seorang dari kalian pintu kebaikan, hendaknya bersegera memasukinya. Sebab, sesungguhnya ia tidak tahu kapan pintu itu akan tertutup baginya."

Mumpung hati sedang tergerak, mumpung raga masih sehat, segera eksekusi niat baik itu. Jangan sampai kita baru ingin masuk saat pintunya sudah terkunci.

Pintu kebaikan apa yang sedang terbuka di hadapanmu hari ini?`
    },
    {
        id: 7,
        title: 'Ramadhan Terakhir Kita',
        tag: 'Ramadhan',
        src: '/flayer 080326/Ramadhan Terakhir Kita.jpeg',
        color: '#10b981',
        desc: `BISA JADI INI RAMADHAN TERAKHIR KITA... 🌙

Kita seringkali menyambut Ramadhan dengan berbagai rencana dan target ibadah. Namun, kita terkadang lupa menyertakan rasa syukur karena Allah masih menunda ajal kita.

Al-Hafizh Ibnu Rajab al-Hanbali rahimahullah mengingatkan sebuah realita pahit: banyak orang yang sudah berencana puasa dan tarawih, namun maut lebih dulu memutus angan-angannya sebelum Ramadhan tiba. 

Kini, kita sudah berada di dalamnya. Nafas yang kita hirup hari ini adalah kesempatan yang sangat dirindukan oleh para penghuni kubur. 

Mari maksimalkan ibadah di bulan suci ini. Berpuasa, shalat, dan bersedekahlah seakan-akan ini adalah Ramadhan perpisahan kita.

Barakallahu fiikum.`
    },
    {
        id: 8,
        title: 'Ganjil Genap Cuma Hitungan',
        tag: 'Ramadhan',
        src: '/flayer 14032026/Ganjil Genap Cuma Hitungan.jpg',
        color: '#10b981',
        desc: `GANJIL ATAU GENAP, KESUNGGUHANLAH YANG JADI PENENTU!

Bismillah.
Sering kali kita terjebak dalam kebiasaan "tebak-tebakan" mencari Lailatul Qadr. Alhasil, saf masjid penuh sesak di malam ganjil, tapi kembali sepi dan longgar di malam genap. Padahal, dirahasiakannya malam mulia ini adalah agar kita memacu diri untuk beribadah di seluruh 10 malam terakhir, bukan hanya di malam-malam tertentu saja.

Syaikh Abdul Aziz bin Baz rahimahullah memberikan kunci sukses yang sangat melegakan hati:
"Seseorang yang bersungguh-sungguh pada 10 hari terakhir seluruhnya... maka dia pasti akan mendapat Lailatul Qadar tanpa diragukan. Dia pasti sukses meraih apa yang telah Allah janjikan..." (Majmu' Fatawa 6/398)

Daripada lelah menerka-nerka kapan jatuhnya malam 1000 bulan tersebut, lebih baik kita "borong" semuanya! Jika kita konsisten menghidupkan setiap malamnya dengan shalat tarawih, tilawah Al-Qur'an, dan munajat, secara otomatis Lailatul Qadr pasti akan masuk ke dalam salah satu malam yang kita hidupkan tersebut.

Mari kencangkan ikat pinggang. Jauhkan sejenak godaan gadget dan rebahan. Jadikan 10 malam terakhir ini sebagai garis finish terbaik kita!`
    },
    {
        id: 9,
        title: 'Hikmah Dibalik Malam Lailatulqadar',
        tag: 'Ilmu',
        src: '/flayer 14032026/Hikmah Dibalik Malam Lailatulqadar.jpg',
        color: '#3b82f6',
        desc: `Pernahkah terbesit di benak kita, mengapa Allah merahasiakan kapan pastinya malam Lailatul Qadr itu tiba? Kenapa tidak disebutkan saja satu tanggal pastinya agar kita bisa langsung fokus bersiap-siap?

Ternyata, di balik rahasia tersebut tersimpan kasih sayang Allah yang amat besar. Syaikh Muhammad bin Shalih al-Utsaimin rahimahullah menjelaskan bahwa disembunyikannya Lailatul Qadr adalah bentuk RAHMAT agar kita memperbanyak amalan, shalat, dzikir, dan doa di sepanjang malam-malam yang mulia tersebut.

Coba bayangkan, jika tanggalnya sudah diketahui secara pasti, sangat mungkin kita hanya akan beribadah semalam saja, lalu kembali lalai dan rebahan di malam-malam lainnya. Dengan dirahasiakannya malam 1000 bulan ini, Allah Ta'ala ingin kita terus memacu ibadah setiap malamnya. Hasilnya? Hati kita akan semakin dekat kepada-Nya dan pahala yang kita panen pun semakin melimpah ruah!

Jangan jadikan ketidaktahuan ini sebagai celah untuk bermalas-malasan. Justru ini adalah "undangan VIP" dari Allah agar kita terus mengetuk pintu rahmat-Nya. Yuk, maksimalkan sisa malam di bulan ini!`
    },
    {
        id: 10,
        title: 'Jangan Biarkan Puasamu Sia-Sia',
        tag: 'Nasehat',
        src: '/flayer 14032026/Jangan Biarkan Puasamu Sia-Sia.jpg',
        color: '#f59e0b',
        desc: `JANGAN BIARKAN PUASA KITA HANYA DAPAT LAPAR DAN DAHAGA

Bismillah.
Pernahkah kita merasa sudah berpuasa seharian penuh, menahan haus di tengah terik matahari, menahan lapar yang melilit perut, namun ternyata di sisi Allah nilainya nol besar? 

Sebuah peringatan keras dari lisan Rasulullah ﷺ untuk kita renungkan:

رُبَّ صَائِمٍ حَظُّهُ مِنْ صِيَامِهِ الْجُوعُ وَالْعَطَشُ
"Betapa banyak orang yang berpuasa namun dia tidak mendapatkan dari puasanya tersebut kecuali rasa lapar dan dahaga." 
(HR. Ath-Thabrani, dinilai shahih lighairihi oleh Syaikh Al-Albani rahimahullah dalam Shahih At-Targhib wa At-Tarhib no. 1084)

Mengapa kerugian besar ini bisa terjadi? Seringkali kita merasa sukses menahan makan dan minum, namun gagal menahan lisan dari dusta dan ghibah, gagal menahan mata dari tontonan yang haram, dan gagal menahan emosi. Maksiat-maksiat inilah yang perlahan menggerogoti dan menggugurkan pahala puasa kita hingga tak tersisa.

Mari perbaiki kualitas puasa kita di sisa hari Ramadhan ini. Jangan sampai jerih payah kita berakhir sia-sia. Sibukkan diri dengan ketaatan, bacaan Al-Qur'an, dan sedekah!`
    }
];

const Infografis = () => {
    const [lightbox, setLightbox] = useState(null); // { idx }

    const openLightbox = (idx) => setLightbox({ idx });
    const closeLightbox = () => setLightbox(null);
    const prevLb = () => setLightbox({ idx: (lightbox.idx - 1 + flyers.length) % flyers.length });
    const nextLb = () => setLightbox({ idx: (lightbox.idx + 1) % flyers.length });

    // Keyboard navigation in lightbox
    React.useEffect(() => {
        if (!lightbox) return;
        const handler = (e) => {
            if (e.key === 'ArrowLeft') prevLb();
            if (e.key === 'ArrowRight') nextLb();
            if (e.key === 'Escape') closeLightbox();
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [lightbox]);

    return (
        <div className="pt-24 min-h-screen bg-[#081c1a] animate-fade-in-up">
            <div className="container mx-auto px-6 py-8">
                {/* Back link */}
                <Link to="/belajar-islam" className="inline-flex items-center gap-2 text-muted-foreground hover:text-gold transition-colors mb-10 group">
                    <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
                    Kembali ke Belajar Islam
                </Link>

                {/* Header */}
                <div className="text-center mb-16">

                    <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4">
                        Flayer Dakwah <span className="text-gold">Thubaproject</span>
                    </h1>
                    <p className="text-muted-foreground max-w-2xl mx-auto text-lg mb-8">
                        Kumpulan flyer dan infografis yang bisa Anda sebarluaskan
                    </p>

                    {/* Call To Action Buttons */}
                    <div className="flex flex-wrap justify-center gap-4">
                        <WaChannelLink
                            className="inline-flex items-center gap-2 px-6 py-3 text-[#081c1a] font-bold rounded-full transition-all duration-300 shadow-lg hover:scale-105"
                            style={{ backgroundColor: '#d4af37' }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                            Channel Whatsapp
                        </WaChannelLink>
                        <a
                            href="https://instagram.com/thubaproject"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 px-6 py-3 text-[#081c1a] font-bold rounded-full transition-all duration-300 shadow-lg hover:scale-105"
                            style={{ backgroundColor: '#d4af37' }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line></svg>
                            Instagram
                        </a>
                    </div>
                </div>

                {/* Grid Flyers */}
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                    {flyers.map((f, idx) => (
                        <div
                            key={f.id}
                            onClick={() => openLightbox(idx)}
                            className="group cursor-pointer rounded-2xl overflow-hidden border border-white/10 hover:border-gold/40 transition-all duration-300 hover:scale-[1.03] hover:shadow-xl relative"
                        >
                            <img src={f.src} alt={f.title} className="w-full h-52 object-cover transition-transform duration-500 group-hover:scale-105" />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-between p-4">
                                <span className="text-white text-sm font-medium">{f.title}</span>
                                <ZoomIn size={20} className="text-gold flex-shrink-0" />
                            </div>
                            <div className="p-4 bg-[#0D2B29]">
                                <span className="text-xs font-bold tracking-wider uppercase" style={{ color: f.color }}>{f.tag}</span>
                                <h3 className="text-white text-sm font-medium mt-1 leading-snug">{f.title}</h3>
                            </div>
                        </div>
                    ))}
                </div>

            </div>

            {/* Lightbox Modal */}
            {lightbox && (
                <div
                    className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 backdrop-blur-sm"
                    onClick={closeLightbox}
                >
                    <div className="relative max-w-3xl w-full" onClick={(e) => e.stopPropagation()}>
                        <img
                            src={flyers[lightbox.idx].src}
                            alt={flyers[lightbox.idx].title}
                            className="w-full h-auto max-h-[60vh] object-contain rounded-2xl"
                        />
                        <div className="text-center mt-4 px-4">
                            <h3 className="text-white text-xl font-serif font-bold mt-1">{flyers[lightbox.idx].title}</h3>
                            {flyers[lightbox.idx].desc && (
                                <div className="mt-4 text-white/80 text-sm md:text-base text-left max-w-2xl mx-auto whitespace-pre-line">
                                    {flyers[lightbox.idx].desc}
                                </div>
                            )}
                        </div>
                        <button onClick={closeLightbox} className="absolute top-3 right-3 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors">
                            <X size={20} className="text-white" />
                        </button>
                        <button onClick={prevLb} className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors">
                            <ChevronLeft size={20} className="text-white" />
                        </button>
                        <button onClick={nextLb} className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors">
                            <ChevronRight size={20} className="text-white" />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Infografis;
